export const environments = {
  LocalDev: 'LocalDev',
  Development: 'Development',
  Staging: 'Staging',
  Production: 'Production',
};

// Internal Urls
export const baseUrlDevelopment =
  'https://tt-d-ncus-web-1-svc.azurewebsites.net';
export const baseUrlDevelopmentLZ =
  'https://tt-d-cus-web-1-svc.azurewebsites.net';
export const baseUrlDevelopmentFriendlyName =
  'https://tt-dev.milwaukeetool.com';
export const baseUrlStaging = 'https://tt-s-ncus-web-1-svc.azurewebsites.net';
export const baseUrlStagingLZ = 'https://tt-s-cus-web-1-svc.azurewebsites.net';
export const baseUrlStagingFriendlyName =
  'https://tt-staging.milwaukeetool.com';
export const baseUrlProduction =
  'https://tt-p-ncus-web-1-svc.azurewebsites.net';
export const baseUrlProductionLZ =
  'https://tt-p-cus-web-1-svc.azurewebsites.net';
export const baseUrlProductionFriendlyName = 'https://tt.milwaukeetool.com';

export const getEnvironment = () => {
  const hostUrl = window.location.origin.toLowerCase();
  if (isLocalhost(hostUrl)) return environments.LocalDev;

  switch (hostUrl) {
    case baseUrlDevelopment:
    case baseUrlDevelopmentLZ:
    case baseUrlDevelopmentFriendlyName:
      return environments.Development;
    case baseUrlStaging:
    case baseUrlStagingLZ:
    case baseUrlStagingFriendlyName:
      return environments.Staging;
    case baseUrlProduction:
    case baseUrlProductionLZ:
    case baseUrlProductionFriendlyName:
      return environments.Production;
    default:
      return null;
  }
};

export const engineeringEnvironment = () => {
  let url = 'https://viper-dev.milwaukeetool.com';
  switch (getEnvironment()) {
    case environments.Production:
      url = `https://viper.milwaukeetool.com`;
      break;
    case environments.Staging:
      url = `https://viper-stage.milwaukeetool.com`;
      break;
    case environments.LocalDev:
    case environments.Development:
      url = `https://viper-dev.milwaukeetool.com`;
      break;
  }
  return url;
};

export const GrsEnvironmentUrl = () => {
  let url = 'https://grs-dev.milwaukeetool.com';
  switch (getEnvironment()) {
    case environments.Production:
      url = `https://grs.milwaukeetool.com`;
      break;
    case environments.Staging:
      url = `https://grs-stage.milwaukeetool.com`;
      break;
    case environments.LocalDev:
    case environments.Development:
      url = `https://grs-dev.milwaukeetool.com`;
      break;
  }
  return url;
};

export const isProdEnvironment = () => {
  return getEnvironment() === environments.Production;
};

const isLocalhost = (hostname) => {
  return Boolean(
    hostname.includes('localhost') ||
      // [::1] is the IPv6 localhost address.
      hostname.includes('::1') ||
      // 127.0.0.1/8 is considered localhost for IPv4.
      hostname.includes('127.0.0.1')
  );
};
